// src/components/NavBar.tsx

import React, { useState } from 'react';
import styled from 'styled-components';
import { FaChartBar, FaCog, FaQuestionCircle, FaLightbulb } from 'react-icons/fa';
import SuggestionModal from './SuggestionModal';

const NavBarContainer = styled.nav`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    background-color: ${({ theme }) => theme.navBackground || '#333'};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const NavItemGroup = styled.div`
    display: flex;
    align-items: center;
`;

const NavTitle = styled.div`
  flex: 1;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.text};

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`;

const NavItem = styled.button`
    background: none;
    border: none;
    color: ${({ theme }) => theme.text};
    font-size: 1.5rem;
    cursor: pointer;
    margin: 0 8px;
    display: flex;
    align-items: center;

    &:hover {
        color: ${({ theme }) => theme.accentColor};
    }

    &:focus {
        outline: none;
    }
`;

interface NavBarProps {
    onOpenSettings: () => void;
    onOpenStatistics: () => void;
    onOpenHowToPlay: () => void;
}

const NavBar: React.FC<NavBarProps> = ({
                                           onOpenSettings,
                                           onOpenStatistics,
                                           onOpenHowToPlay,
                                       }) => {
    const [showSuggestionModal, setShowSuggestionModal] = useState(false);

    return (
        <>
            <NavBarContainer>
                {/* Left Icon Group */}
                <NavItemGroup>
                    {/* Leaderboard Icon */}
                    <NavItem onClick={onOpenStatistics} aria-label="Statistics">
                        <FaChartBar />
                    </NavItem>
                    {/* Suggestion Icon */}
                    <NavItem
                        onClick={() => setShowSuggestionModal(true)}
                        aria-label="Suggestion Box"
                    >
                        <FaLightbulb />
                    </NavItem>
                </NavItemGroup>

                {/* Center Title */}
                <NavTitle>Riddle Ravel</NavTitle>

                {/* Right Icon Group */}
                <NavItemGroup>
                    {/* How to Play Icon */}
                    <NavItem onClick={onOpenHowToPlay} aria-label="How to Play">
                        <FaQuestionCircle />
                    </NavItem>
                    {/* Settings Icon */}
                    <NavItem onClick={onOpenSettings} aria-label="Settings">
                        <FaCog />
                    </NavItem>
                </NavItemGroup>
            </NavBarContainer>

            {showSuggestionModal && (
                <SuggestionModal
                    onClose={() => setShowSuggestionModal(false)}
                />
            )}
        </>
    );
};

export default NavBar;
